import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import WaterIcon from "@mui/icons-material/Water";
import Management from "../../Team/components/Management";

const Team = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "3% 0%" }}>
      <Typography
        variant="h6"
        color="#317ABE"
        fontWeight={700}
        paddingBottom={"2%"}
        textAlign={"left"}
      >
        <Box component={"span"}>
          <WaterIcon
            sx={{
              width: 23,
              height: 23,
            }}
          />
        </Box>{" "}
        Our Key Management Staff
      </Typography>
      <Box>
        <Management />
      </Box>
    </Box>
  );
};

export default Team;
